/**
 * Field codes, label maps, and time-range options for the PLOTFX command/chart.
 *
 * Field semantics (per plotfx REQUIREMENT.md):
 *  - PTS      forward points
 *  - OUT      forward outright
 *  - YLD      implied zero yield (Simple convention)
 *  - BASIS    NDF-vs-NDOIS yield basis (leg1 - leg2)
 *  - PTS_YLD  both PTS and YLD together (default when no field is supplied)
 */

export const FX_FIELDS = Object.freeze({
    PTS: 'PTS',
    OUT: 'OUT',
    YLD: 'YLD',
    BASIS: 'BASIS',
    PTS_YLD: 'PTS_YLD'
});

export const FX_FIELD_QUERY = Object.freeze({
    PTS: 'pts',
    OUT: 'out',
    YLD: 'yld',
    BASIS: 'basis',
    PTS_YLD: 'ptsyld'
});

export const FX_FIELD_FROM_QUERY = Object.freeze({
    pts: FX_FIELDS.PTS,
    out: FX_FIELDS.OUT,
    yld: FX_FIELDS.YLD,
    basis: FX_FIELDS.BASIS,
    ptsyld: FX_FIELDS.PTS_YLD
});

export const FX_FIELD_LABEL = Object.freeze({
    [FX_FIELDS.PTS]: 'PTS',
    [FX_FIELDS.OUT]: 'OUT',
    [FX_FIELDS.YLD]: 'YLD',
    [FX_FIELDS.BASIS]: 'BASIS',
    [FX_FIELDS.PTS_YLD]: 'PTS + YLD'
});

export const FX_DEFAULT_FIELD = FX_FIELDS.PTS_YLD;

export const FX_PLOT_RANGES = Object.freeze([
    { label: '1D', unit: 'D', value: 1 },
    { label: '1W', unit: 'W', value: 1 },
    { label: '1M', unit: 'M', value: 1 },
    { label: '6M', unit: 'M', value: 6 },
    { label: 'YTD', unit: 'YTD', value: 0 },
    { label: '1Y', unit: 'Y', value: 1 },
    { label: '2Y', unit: 'Y', value: 2 },
    { label: '5Y', unit: 'Y', value: 5 },
    { label: 'MAX', unit: 'max', value: -1 }
]);

export const FX_DEFAULT_RANGE_LABEL = '2Y';

export const FX_SHOW_MODES = Object.freeze({
    YLD: 'YLD',
    PTS: 'PTS',
    BOTH: 'BOTH'
});

export const FX_DEFAULT_SHOW = FX_SHOW_MODES.BOTH;

export const FX_SCALE_MODES = Object.freeze({
    DUAL: 'DUAL',
    SINGLE: 'SINGLE'
});

export const FX_DEFAULT_SCALE = FX_SCALE_MODES.DUAL;

/**
 * Hint text shown next to PLOTFX in the command-bar autocomplete.
 * Must match section 1 of the requirement verbatim.
 */
export const PLOTFX_HINT = 'PLOTFX - Plot FX Graph <Currency> [Tenor(s)]';
export const PLOTFX_HINT_EXAMPLES = ['PLOTFX AUDUSD', 'PLOTFX AUDUSD 1Y PTS', 'PLOTFX AUDUSD 1Y YLD'];
